import * as React from "react";
import styled from "styled-components";

import HERO_BG from "../../../../img/pages/home/hero_bg.svg";
import HERO_ILLUSTRATION from "../../../../img/pages/home/hero_illustration.svg";
import { Color } from "../../../constants/legacy";
import HorizontalContainer from "../HorizontalContainer";
import Button from "../Button";
import FormattedRichText from "../FormattedRichText";

type Props = {
  title: string | undefined;
  subTitle: string | undefined;
  buttonLabel: string | undefined;
};

/**
 * This has too many differences from the typical `Hero` that makes more sense
 * to just do this as a brand new component, rather than adding further props
 * customisation to that.
 */
export default function HomeHero({ title, subTitle, buttonLabel }: Props) {
  return (
    <StyledSection>
      <StyledBackground src={HERO_BG} />
      <StyledAreaMain>
        <StyledColText>
          <h1>{title}</h1>
          <FormattedRichText render={subTitle} fontSize={16} />
          <Button
            to="/contact"
            color="orange"
            label={buttonLabel || "Request a demo"}
          />
        </StyledColText>
        <StyledColIllustration>
          <img src={HERO_ILLUSTRATION} />
        </StyledColIllustration>
      </StyledAreaMain>
    </StyledSection>
  );
}

const StyledSection = styled.section`
  background-color: #fff;
  position: relative;
  overflow: hidden;
`;

const StyledBackground = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  /* left: 30%; */
  right: -200px;
  pointer-events: none;
  user-select: none;
  width: 1250px;
  height: 1250px;
  transform: translateY(-50%);
`;

const StyledAreaMain = styled(HorizontalContainer)`
  min-height: 720px;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 640px) {
    min-height: 540px;
  }
`;

const StyledColText = styled.div`
  flex: 1;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1 {
    color: ${Color.orange};
    font-weight: 500;
    font-size: 36px;
    max-width: 440px;
    margin: 0;
  }

  p {
    margin: 20px 0 30px !important;
    max-width: 440px;
  }
`;

const StyledColIllustration = styled.div`
  flex: 1;

  @media (max-width: 640px) {
    display: none;
  }

  img {
    width: 100%;
    margin-right: -30%;
  }
`;
